webpackJsonp([21],{

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(559)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(593),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8838d296",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 497:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "MassAllItemsLanguage",
  data: function data() {
    return {
      language: this.$cookie.get('lang') || 'en',
      languages: JSON.parse(localStorage.languages),
      inputLang: null,
      outputLang: null,
      scope: [{ value: 'abbrevation', name: this.$lang.header.abbrevation + ' ' + this.$lang.actions.overwrite, selected: true }, { value: 'name', name: this.$lang.header.name + ' ' + this.$lang.actions.overwrite, selected: true }, { value: 'description', name: this.$lang.header.description + ' ' + this.$lang.actions.overwrite, selected: true }, { value: 'sizes', name: this.$lang.header.sizes + ' ' + this.$lang.actions.overwrite, selected: true }, { value: 'options', name: this.$lang.header.options + ' ' + this.$lang.actions.overwrite, selected: true }, { value: 'variants', name: this.$lang.header.variants + ' ' + this.$lang.actions.overwrite, selected: true }, { value: 'styles', name: this.$lang.header.styles + ' ' + this.$lang.actions.overwrite, selected: true }],
      err: ''
    };
  },

  watch: {
    err: function err(val) {
      var _this = this;

      if (val !== '') {
        setTimeout(function () {
          _this.err = '';
        }, 5000);
      }
    }
  },
  methods: {
    submitTranslate: function submitTranslate() {
      if (!this.inputLang || !this.outputLang) {
        this.err = this.$lang.errors.inputOutputLangs;
        return;
      }
      if (this.inputLang === this.outputLang) {
        this.err = this.$lang.errors.inputOutputLangsSame;
        return;
      }
      var submitObj = {};
      submitObj.scope = this.scope;
      submitObj.inputLang = this.inputLang;
      submitObj.outputLang = this.outputLang;
      this.$emit('submit', submitObj);
    }
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(451)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"MassAllItemsLanguage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(533);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(452)("94d32620", content, true, {});

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$lang.header.massTranslate))]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-select', {
    staticClass: "pt-0 mt-2 max-w",
    attrs: {
      "label": _vm.$lang.labels.inputLanguage,
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.inputLang),
      callback: function($$v) {
        _vm.inputLang = $$v
      },
      expression: "inputLang"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "pt-0 mt-2 max-w",
    attrs: {
      "label": _vm.$lang.labels.outputLanguage,
      "items": _vm.languages,
      "item-text": "text",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.outputLang),
      callback: function($$v) {
        _vm.outputLang = $$v
      },
      expression: "outputLang"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "checkbox-wrap my-4",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.overwriteOptions))])]), _vm._v(" "), _vm._l((_vm.scope), function(item, index) {
    return _c('v-flex', {
      key: index,
      attrs: {
        "xs4": ""
      }
    }, [_c('v-checkbox', {
      attrs: {
        "color": "primary",
        "label": item.name
      },
      model: {
        value: (item.selected),
        callback: function($$v) {
          _vm.$set(item, "selected", $$v)
        },
        expression: "item.selected"
      }
    })], 1)
  })], 2), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitTranslate()
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang.actions.submit))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/21.557ca735e265b18fc73d.js